function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerGold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto",
      animationPlayState: "running",
      animationDelay: "0s"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 24,
    rx: 0.5,
    ry: 6,
    width: 1,
    height: 12,
    fill: "#cda96c",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.9166666666666666s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(30 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 24,
    rx: 0.5,
    ry: 6,
    width: 1,
    height: 12,
    fill: "#cda96c",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.8333333333333334s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 24,
    rx: 0.5,
    ry: 6,
    width: 1,
    height: 12,
    fill: "#cda96c",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.75s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 24,
    rx: 0.5,
    ry: 6,
    width: 1,
    height: 12,
    fill: "#cda96c",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.6666666666666666s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 24,
    rx: 0.5,
    ry: 6,
    width: 1,
    height: 12,
    fill: "#cda96c",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5833333333333334s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(150 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 24,
    rx: 0.5,
    ry: 6,
    width: 1,
    height: 12,
    fill: "#cda96c",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 24,
    rx: 0.5,
    ry: 6,
    width: 1,
    height: 12,
    fill: "#cda96c",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.4166666666666667s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(210 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 24,
    rx: 0.5,
    ry: 6,
    width: 1,
    height: 12,
    fill: "#cda96c",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.3333333333333333s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 24,
    rx: 0.5,
    ry: 6,
    width: 1,
    height: 12,
    fill: "#cda96c",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.25s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 24,
    rx: 0.5,
    ry: 6,
    width: 1,
    height: 12,
    fill: "#cda96c",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.16666666666666666s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(300 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 24,
    rx: 0.5,
    ry: 6,
    width: 1,
    height: 12,
    fill: "#cda96c",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.08333333333333333s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(330 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 24,
    rx: 0.5,
    ry: 6,
    width: 1,
    height: 12,
    fill: "#cda96c",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerGold);
export default __webpack_public_path__ + "static/media/spinner-gold.ba574d67480531cc634de6a78dbd1a0e.svg";
export { ForwardRef as ReactComponent };